import {
    FETCH_DAILY_TOTAL_CALORIES_REPORTS,
    FETCH_DAILY_TOTAL_CALORIES_REPORTS_FETCHING,
    FETCH_DAILY_TOTAL_CALORIES_REPORTS_SUCCESS,
    FETCH_DAILY_TOTAL_CALORIES_REPORTS_FAIL,
    FETCH_WEEKLY_TOTAL_CALORIES_REPORTS,
    FETCH_WEEKLY_TOTAL_CALORIES_REPORTS_FETCHING,
    FETCH_WEEKLY_TOTAL_CALORIES_REPORTS_SUCCESS,
    FETCH_WEEKLY_TOTAL_CALORIES_REPORTS_FAIL
} from '../../actions/totalCaloriesActions';
import { RESET_PROFILE_PAGE } from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    dailyTotalCalories: [],
    dailyCaloriesAverage: null,
    dailyTotalCaloriesFetching: false,
    dailyTotalCaloriesFetchFail: false,
    weeklyTotalCalories: [],
    weeklyTotalCaloriesFetching: false,
    weeklyTotalCaloriesFetchFail: false
};

// ======= Daily Fetching Handlers =======
const fetchDailyTotalCaloriesFetching = (state) => {
    return {
        ...state,
        dailyTotalCaloriesFetching: true,
        dailyTotalCaloriesFetchFail: false
    };
};

const fetchDailyTotalCaloriesSuccess = (state, action) => {
    return {
        ...state,
        dailyTotalCalories: action.dailyTotalCalories.values,
        dailyCaloriesAverage: action.dailyTotalCalories.aggregations,
        dailyTotalCaloriesFetching: false,
        dailyTotalCaloriesFetchFail: false
    };
};

const fetchDailyTotalCaloriesFail = (state) => {
    return {
        ...state,
        dailyTotalCaloriesFetching: false,
        dailyTotalCaloriesFetchFail: true
    };
};

// ======= Weekly Fetching Handlers =======
const fetchWeeklyTotalCaloriesFetching = (state) => {
    return {
        ...state,
        weeklyTotalCaloriesFetching: true,
        weeklyTotalCaloriesFetchFail: false
    };
};

const fetchWeeklyTotalCaloriesSuccess = (state, action) => {
    return {
        ...state,
        weeklyTotalCalories: action.weeklyTotalCalories,
        weeklyTotalCaloriesFetching: false,
        weeklyTotalCaloriesFetchFail: false
    };
};

const fetchWeeklyTotalCaloriesFail = (state) => {
    return {
        ...state,
        weeklyTotalCaloriesFetching: false,
        weeklyTotalCaloriesFetchFail: true
    };
};

const resetToInitialState = () => INITIAL_STATE;

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DAILY_TOTAL_CALORIES_REPORTS_FETCHING]: fetchDailyTotalCaloriesFetching,
    [FETCH_DAILY_TOTAL_CALORIES_REPORTS_SUCCESS]: fetchDailyTotalCaloriesSuccess,
    [FETCH_DAILY_TOTAL_CALORIES_REPORTS_FAIL]: fetchDailyTotalCaloriesFail,
    [FETCH_WEEKLY_TOTAL_CALORIES_REPORTS_FETCHING]: fetchWeeklyTotalCaloriesFetching,
    [FETCH_WEEKLY_TOTAL_CALORIES_REPORTS_SUCCESS]: fetchWeeklyTotalCaloriesSuccess,
    [FETCH_WEEKLY_TOTAL_CALORIES_REPORTS_FAIL]: fetchWeeklyTotalCaloriesFail,
    [RESET_PROFILE_PAGE]: resetToInitialState
};

// ======= Default Action ======
export default function totalCaloriesReports(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchDailyTotalCalories(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_DAILY_TOTAL_CALORIES_REPORTS,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function fetchWeeklyTotalCalories(payload, evictCache) {
    return {
        type: FETCH_WEEKLY_TOTAL_CALORIES_REPORTS,
        payload: payload,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

// ======= Selectors =======
export const getDailyTotalCalories = (state) => {
    return state.totalCaloriesReports.dailyTotalCalories ? state.totalCaloriesReports.dailyTotalCalories : null;
};

export const getDailyCaloriesAverage = (state) => {
    return state.totalCaloriesReports.dailyCaloriesAverage ? state.totalCaloriesReports.dailyCaloriesAverage : null;
};

export const isDailyTotalCaloriesFetching = (state) => {
    return state.totalCaloriesReports.dailyTotalCaloriesFetching;
};

export const didDailyTotalCaloriesFetchFail = (state) => {
    return state.totalCaloriesReports.dailyTotalCaloriesFetchFail;
};

export const getWeeklyTotalCalories = (state) => {
    return state.totalCaloriesReports.weeklyTotalCalories ? state.totalCaloriesReports.weeklyTotalCalories : null;
};

export const isWeeklyTotalCaloriesFetching = (state) => {
    return state.totalCaloriesReports.weeklyTotalCaloriesFetching;
};

export const didWeeklyTotalCaloriesFetchFail = (state) => {
    return state.totalCaloriesReports.weeklyTotalCaloriesFetchFail;
};
